import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { MessageFactory } from "../../../lib/messages";
// import { Protocol, Globals } from "../../../lib/constants";
// import { ReactComponent as Usdsvg } from "./usd.svg";
import currencies from "../../../lib/currencies/currencies";
import { logger } from '../../../App'
import { ReactComponent as InfiniteSVG } from "./infinite.svg";
import { Frame, ScalingContainer } from "../../../AppStyled";
import useSound from "use-sound";

import forwardSound from "../../../audio/goForward.mp3";
import closeSound from "../../../audio/goBack.mp3";
import switchSound from "./audio/switch.mp3";
import {
  // AutorulesDiv,
  Title,
  InputDiv,
  InputBig,
  StopOnInput,
  Input,
  Reset,
  Increase,
  Bet,
  Opr,
  BetQuantity,
  AutoRuleBox,
  PlayBtn,
  BackBtn,
  ProfitBox,
} from "./AutoRulesStyled";

import { useDispatch } from "react-redux";
import { handleBet as handleBetForRDX } from "../../../redux/actions/postActions";

import { ReactComponent as PlusSVG } from "../../../svg/plusAutoRules.svg";
import { ReactComponent as MinusSVG } from "../../../svg/minusAutoRules.svg";

// import AutoRollLogic from "./autoroll";

import useBetOperations from "../bet/useBetOperations";
// import { useSendSettings } from "../../otherPages/settings/useSendSettings";

export default function Autorules(props) {
  const { sound, volume } = props;
  const [numberOfBets, setnumberOfBets] = useState(0);
  const [onWinReset, setonWinReset] = useState(false);
  const [onWinPercent, setonWinPercent] = useState(0);
  const [onLossReset, setonLossReset] = useState(false);
  const [onLossPercent, setonLossPercent] = useState(0);
  const [stopOnProfit, setstopOnProfit] = useState(0);
  const [stopOnLoss, setstopOnLoss] = useState(0);

  const [animSG, setanimSG] = useState(false);
  // const [clicked, setclicked] = useState(false);
  const [plusPress, setPlusPress] = useState(false);
  const [minusPress, setMinusPress] = useState(false);
  const dispatch = useDispatch();

  const st = useSelector((s) => s);
  const { bet, autoRulesConfigs, balance } = st;
  const [useBet, plus, minus, , , handleButtonPress, handleButtonRelease] =
    useBetOperations(
      bet,
      true,
      sound,
      props.handleNotification,
      props.toFix,
      props.gameState.minBet,
      props.gameState.maxBet,
      props.currency,
    );
  useEffect(() => {
    setbetInAuto(useBet);
    setinputBet(useBet);
  }, [useBet]);
  const [infinite, setInfinite] = useState(true);

  // const [, sendAutoRulesConfigs] = useSendSettings();
  useEffect(() => {
    setnumberOfBets(autoRulesConfigs.numberOfBets);
    setonWinReset(autoRulesConfigs.onWinReset);
    setonWinPercent(autoRulesConfigs.onWinPercent);
    setonLossReset(autoRulesConfigs.onLossReset);
    setonLossPercent(autoRulesConfigs.onLossPercent);
    setstopOnProfit(autoRulesConfigs.stopOnProfit);
    setstopOnLoss(autoRulesConfigs.stopOnLoss);
  }, [
    autoRulesConfigs,
    setnumberOfBets,
    setonWinReset,
    setonWinPercent,
    setonLossReset,
    setonLossPercent,
    setstopOnProfit,
    setstopOnLoss,
  ]);

  const handleClick = (a, b) =>
    a === "win" ? setonWinReset(b) : setonLossReset(b);

  const handleNumBetBlur = (e) => {
    const n = e.target.value;
    if (n === "" || n === "0") {
      setnumberOfBets("");
      setInfinite(true);
    } else {
      setnumberOfBets(n);
      setInfinite(false);
    }
  };

  const handleInput = (e) => {
    const reg = /^\d*\.?\d*$/;

    const reg2 = /^[0-9]*$/;
    const name = e.target.name;

    if (
      (reg.test(e.target.value) && e.target.value >= 0) ||
      e.target.value === ""
    ) {
      switch (name) {
        case "numberOfBets":
          if (e.target.value === 0 || e.target.value === "") {
            setInfinite(true);
          }
          if (reg2.test(e.target.value)) {
            setnumberOfBets(e.target.value);
            setInfinite(false);
          }
          break;
        case "onWinPercent":
          setonWinReset(false);
          setonWinPercent(e.target.value);
          break;
        case "onLossPercent":
          setonLossReset(false);
          setonLossPercent(e.target.value);
          break;
        case "stopOnProfit":
          setstopOnProfit(e.target.value);
          break;
        case "stopOnLoss":
          setstopOnLoss(e.target.value);
          break;

        default:
          if (
            (reg.test(e.target.value) && e.target.value >= 0) ||
            e.target.value === ""
          ) {
            logger.log(name);
          }

          break;
      }
    }
  };
  const handlePlay = () => {
    props.handleAutoRollLogic({
      numberOfBets,
      onWinReset,
      onWinPercent,
      onLossReset,
      onLossPercent,
      stopOnProfit,
      stopOnLoss,
      useBet,
    });
    props.handleAbove(false);
  };
  const [betInAuto, setbetInAuto] = useState(bet || "");

  const [inputBet, setinputBet] = useState(betInAuto);

  const max = props.gameState.maxBet;
  const min = props.gameState.minBet;

  const handleBet = (q) => {
    const e = q.target.value;
    // const reg = /^-?\d+\.?\d*$/;
    const reg = /^\d*\.?\d*$/;

    if (reg.test(e) || e === "") {
      setinputBet(e);
    }
  };
  const handleBlur = (e) => {
    const n = e.target.value;

    if (n < min || n === "") {
      setbetInAuto(min);
      dispatch(handleBetForRDX(min));
      setinputBet(min);
    } else if (n >= max) {
      setbetInAuto(max);
      setinputBet(max);
      dispatch(handleBetForRDX(max));
    } else {
      setbetInAuto(n);
      setinputBet(n);
      dispatch(handleBetForRDX(n));
    }
  };

  const handleStopOnBlur = (e, name) => {
    const value = e.target.value
    const format = value === '' || Number(value) === 0 ? 0 : (+value).toFixed(props.toFix)
    name === 'profit' ? setstopOnProfit(format) : setstopOnLoss(format)
  }
  const [closeSFX] = useSound(closeSound, { volume });
  const [forwardSFX] = useSound(forwardSound, { volume });
  const [switchSFX] = useSound(switchSound, { volume });
  const [clicked, setclicked] = useState(false);

  return (
    <Frame
      className="Frame"
      unBlur={props.unBlur}
      style={props.display ? { display: "flex" } : { display: "none" }}
      opacity="true"
      scrollable={props.scrollable}
    >
      <ScalingContainer className="ScalingContainer" h={props.h}>
        <AutoRuleBox>
          <Title>Number Of Bets </Title>
          <InputBig
            data-autocomplete
            name="numberOfBets"
            type="text"
            // placeholder={numberOfBets}
            placeholder={
              numberOfBets !== "0" && numberOfBets !== "" ? numberOfBets : ""
            }
            value={
              numberOfBets !== "0" && numberOfBets !== "" ? numberOfBets : ""
            }
            onChange={handleInput}
            maxLength="4"
            onBlur={handleNumBetBlur}
            onFocus={() => setInfinite(false)}
          />
          {(numberOfBets === "" || numberOfBets === "0") && infinite ? (
            <InfiniteSVG className="infinite" />
          ) : null}
        </AutoRuleBox>
        <AutoRuleBox>
          <Title>on win</Title>
          <InputDiv>
            <Reset
              active={onWinReset}
              onClick={() => {
                if (sound && !onWinReset) switchSFX();
                handleClick("win", true);
              }}
            >
              <div className="yellow" />
              <div className="white" />
              <p> Reset </p>
            </Reset>
            <Increase
              id="increase"
              active={!onWinReset}
              onClick={() => {
                if (sound && onWinReset) switchSFX();
                handleClick("win", false);
              }}
            >
              <div className="yellow" />
              <div className="white" />
              <p> Increase by </p>
            </Increase>
            <div>
              <Input
                name="onWinPercent"
                maxLength="4" /// ????
                placeholder={onWinPercent}
                value={onWinPercent}
                onChange={handleInput}
              />
              %
            </div>
          </InputDiv>
        </AutoRuleBox>
        <AutoRuleBox>
          <Title>on loss</Title>
          <InputDiv>
            <Reset
              active={onLossReset}
              onClick={() => {
                if (sound && !onLossReset) switchSFX();
                handleClick("loss", true);
              }}
            >
              <div className="yellow" />
              <div className="white" />
              <p> Reset </p>
            </Reset>
            <Increase
              active={!onLossReset}
              onClick={() => {
                if (sound && onLossReset) switchSFX();
                handleClick("loss", false);
              }}
            >
              <div className="yellow" />
              <div className="white" />
              <p> Increase by </p>
            </Increase>
            <div>
              <Input
                name="onLossPercent"
                maxLength="4"
                placeholder={onLossPercent}
                value={onLossPercent}
                onChange={handleInput}
              />
              %
            </div>
          </InputDiv>
        </AutoRuleBox>
        <ProfitBox>
          <AutoRuleBox>
            <Title>stop on profit</Title>
            <StopOnInput>
              {currencies[props.currency]}
              <input
                name="stopOnProfit"
                maxLength="11"
                placeholder={stopOnProfit}
                value={stopOnProfit}
                onChange={handleInput}
                onBlur={(e) => handleStopOnBlur(e, 'profit')}
              />
            </StopOnInput>
          </AutoRuleBox>
          <AutoRuleBox>
            <Title>stop on loss</Title>
            <StopOnInput>
              {currencies[props.currency]}
              <input
                name="stopOnLoss"
                maxLength="11"
                placeholder={stopOnLoss}
                value={stopOnLoss}
                onChange={handleInput}
                onBlur={(e) => handleStopOnBlur(e, 'loss')}
              />
            </StopOnInput>
          </AutoRuleBox>
        </ProfitBox>

        <Bet>
          <Opr
            minusPress={minusPress}
            onClick={minus}
            onTouchStart={() => {
              setMinusPress(true);
              handleButtonPress("acceleratableMinus");
            }}
            onTouchEnd={() => {
              setMinusPress(false);
              handleButtonRelease();
            }}
            onMouseDown={() => {
              setMinusPress(true);
              handleButtonPress("acceleratableMinus");
            }}
            onMouseUp={() => {
              setMinusPress(false);
              handleButtonRelease();
            }}
            onMouseLeave={() => {
              setMinusPress(false);
              handleButtonRelease();
            }}
          >
            <MinusSVG />
          </Opr>
          <BetQuantity>
            {currencies[props.currency]}
            <input
              type="text"
              maxLength="10"
              value={inputBet}
              onChange={handleBet}
              onBlur={handleBlur}
            />
          </BetQuantity>
          <Opr
            plusPress={plusPress}
            onClick={plus}
            onTouchStart={() => {
              setPlusPress(true);
              handleButtonPress("acceleratablePlus");
            }}
            onTouchEnd={() => {
              setPlusPress(false);
              handleButtonRelease();
            }}
            onMouseDown={() => {
              setPlusPress(true);
              handleButtonPress("acceleratablePlus");
            }}
            onMouseUp={() => {
              setPlusPress(false);
              handleButtonRelease();
            }}
            onMouseLeave={() => {
              setPlusPress(false);
              handleButtonRelease();
            }}
          >
            <PlusSVG />
          </Opr>
        </Bet>
        <PlayBtn
          onClick={() => {
            if (!clicked) {
              if (inputBet > balance) {
                return props.handleNotification("Not enough balance");
              }
              setclicked(true);
              if (sound) forwardSFX();
              setTimeout(() => {
                handlePlay();
              }, 500);
              setanimSG(true);
              setTimeout(() => {
                setclicked(false);
              }, 1500);
            }
          }}
          animSG={animSG}
        >
          <div className="yellow" />
          <div className="white" />
          Start Game
        </PlayBtn>
        <BackBtn
          onClick={() => {
            if (sound) closeSFX();
            props.handleAbove(false);
          }}
        >
          back
        </BackBtn>
      </ScalingContainer>
    </Frame>
  );
}
